import React, { useState,useRef,useEffect} from 'react';
import logo from './logo.svg';
import './App.css';
import { FullPage, Slide } from 'react-full-page';
import Slider from "react-slick";
import "../node_modules/slick-carousel/slick/slick.css"; 
import "../node_modules/slick-carousel/slick/slick-theme.css";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import 'animate.css';
import { Button,Modal } from 'react-bootstrap';
import Fbxloder from './component/Fbxloader'
import routes from './router';
import FacebookLogin from 'react-facebook-login';
import {reactLocalStorage} from 'reactjs-localstorage';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import axios from "axios";
import ThreeSixty from 'react-360-view'
import {Helmet} from "react-helmet";
function Fbxmodal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      dialogClassName="modal-90w modal-wheel"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          360°
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <ThreeSixty
          amount={27}
          imagePath="../360"
          fileName="frame_{index}.png?v1"
          spinReverse={true}
      />
      </Modal.Body>
    </Modal>
  );
}
function Contactmodal(props) {
  const [contactfrm, setContactfrm] = useState({name:"",email:"",phone:"",msg:""});
  const [frmStatus, setFrmStatus] = useState(false);
  const setInputValue = (e)=>{
    const {value,name} = e.target;
    setContactfrm(oldValues=>({...oldValues, [name]:value}));
  }
  const sendContact=()=>{
    let bodyFormData = new FormData();
    bodyFormData.append('name', contactfrm.name);
    bodyFormData.append('email', contactfrm.email);
    bodyFormData.append('phone', contactfrm.phone);
    bodyFormData.append('msg', contactfrm.msg);
    console.log("Form Contact =>", contactfrm);
    axios({
      method: "post",
      url: "https://www.goodyear.co.th/assurance-maxguard-suv/services/api/V1/contact",
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data" },
    }).then(function (response) {
      setFrmStatus(true)
      setContactfrm({name:"",email:"",phone:"",msg:""});
    }).catch(function (response) {
      setContactfrm({name:"",email:"",phone:"",msg:""});
      setFrmStatus(true)
    });
   
  }
  const handleClose=()=>{
    if(frmStatus){
      window.location.reload()
    }
  }
  return (
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="contact-modal"
        backdrop='static'
        keyboard= {false}
        fullscreen={(isMobile)?true:false}
      >
      <Modal.Header closeButton onHide={()=>handleClose()}>
        <Modal.Title id="contained-modal-title-vcenter">
          ติดต่อเรา
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          หากมีคำถามหรือข้อสงสัยกรุณากรอกข้อมูลของท่าน<br/>จากนั้นเจ้าหน้าที่จะติดต่อกลับ เพื่อตอบทุกคำถามที่ท่านอยากทราบ
        </p>
        <div className="row">
          <div className="col-12 mb-2">
            <div className="form-group">
              <label>ชื่อ-นามสกุล<sup>*</sup></label>
              <input type="text" className="form-control" id="txt_name" value={contactfrm.name} name="name" onChange={setInputValue}/>
            </div>
          </div>
          <div className="col-12 mb-2">
            <div className="form-group">
              <label>อีเมล<sup>*</sup></label>
              <input type="email" className="form-control" id="txt_email" value={contactfrm.email}  name="email" onChange={setInputValue}/>
            </div>
          </div>
          <div className="col-12 mb-2">
            <div className="form-group">
              <label>เบอร์โทรศัพท์</label>
              <input type="tel" className="form-control" id="txt_tel" value={contactfrm.phone}  name="phone" onChange={setInputValue}/>
            </div>
          </div>
          <div className="col-12 mb-4">
            <div className="form-group">
              <label>รายละเอียดที่ต้องการติดต่อ<sup>*</sup></label>
              <textarea type="text" className="form-control" id="txt_detail"  value={contactfrm.msg} name="msg" onChange={setInputValue}/>
            </div>
          </div>
          <div className="col-12 text-center mb-4">
            <button type="button" onClick={()=>sendContact()}>ส่งข้อความ</button>
          </div>
          {
            (frmStatus)?
            <div className="alert alert-success" role="alert">
              ส่งข้อมูลเรียบร้อย ทางเราจะรีบดำเนินการติดต่อกลับโดยเร็ว
            </div>
            :
            <></>
          }
          
        </div>
      </Modal.Body>
    </Modal>
  );
}

function Mainpage() {
  const vidRef1 = useRef(null);
  const vidRef2 = useRef(null);
  const vidRef3 = useRef(null);
  const vidRef4 = useRef(null);
  const [VIndex, setVIndex] = useState(0);
  const sliderRef = useRef();
  const [sliderIndex,setsliderIndex] = useState(0);
  
  const toggleTab =(index)=>{
    if(index===0){
      setTabIndex(1)
    }else{
      setTabIndex(0)
    }
  }
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000
  };
  const settings2 = {
    centerMode: true,
    centerPadding: '120px',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '60px',
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '60px',
          slidesToShow: 1
        }
      }
    ],
    beforeChange: (index, next) => {
      setsliderIndex(next)
    }
  };

  const [vdoActive3,setvdoActive3] = useState(false)
  const [vdoActive4,setvdoActive4] = useState(false)
  const [clipActive,setClipActive] = useState(1)
  const [showmenu,setShowmenu] = useState(false)
  const [clickmenu,setClickmenu] = useState(false)
  const [activeSlide,setActiveSlide] = useState(0)
  const mainVdo = useRef(null);
  const [modalShow, setModalShow] =  useState(false)
  const [ContactModalShow, setContactModalShow] =  useState(false)
  const [ThankyouModalShow, setThankyouModalShow] =  useState(false)
  const [login, setLogin] = useState(false);
  const [data, setData] = useState({});
  const [picture, setPicture] = useState("");
  const [SlideIndex, setSlideIndex] = useState(0);
  const [tabIndex, setTabIndex] = useState(0);
  const [scrollDetect,setscrollDetect] = useState(false);
  const [scrollDetectVdo,setscrollDetectVdo] = useState(false);
  const [y, setY] = useState(window.scrollY);
  const [VideoIndex, setVideoIndex] = useState(0);
  let oldCount = 0
  const videoLists = [
    {"poster":"../vdo_bg3.jpg","url":"../video/Parking Guard.mp4"},
    {"poster":"../vdo_bg2.jpg","url":"../video/Road fight.mp4"},
    {"poster":"../vdo_bg4.jpg","url":"../video/GoodYear_Edit_101121_2.mp4"},
    {"poster":"../vdo_bg.jpg","url":"../video/AMG SUV SubThai-Final_converted.mp4"}
  ]
  const clikVideo=(index)=>{
    oldCount = VideoIndex
    setVideoIndex(index)
    mainVdo.current.load()
    mainVdo.current.play()
  }
  const toggleContactModal =()=>{
    togglemenu()
    setContactModalShow(!ContactModalShow)
  }

  const togglemenu =()=>{
   if(isMobile){
    setTimeout(function(){window.scrollTo(0, document.documentElement.scrollTop-72)}, 500);
   }
    setClickmenu(true)
    if(showmenu){
      setShowmenu(false)
    }else{
      setShowmenu(true)
    }
  }
  const togglemenu1 =()=>{
   if(isMobile){
    setTimeout(function(){window.scrollTo(0, document.documentElement.scrollTop-72)}, 500);
   }
    setClickmenu(true)
    setTabIndex(0)
    if(showmenu){
      setShowmenu(false)
    }else{
      setShowmenu(true)
    }
    if(isMobile){
      sliderRef.current.slickGoTo(0)
    }
  }
  const togglemenu2 =()=>{
    setClickmenu(true)
   if(isMobile){
    setTimeout(function(){window.scrollTo(0, document.documentElement.scrollTop-72)}, 500);
   }
    setTabIndex(0)
    if(showmenu){
      setShowmenu(false)
    }else{
      setShowmenu(true)
    }
    if(isMobile){
      sliderRef.current.slickGoTo(2)
    }
  }
  const togglemenu3 =()=>{
    
   if(isMobile){
    setTimeout(function(){window.scrollTo(0, document.documentElement.scrollTop-72)}, 500);
   }
    setTabIndex(1)
    setClickmenu(true)
    if(showmenu){
      setShowmenu(false)
    }else{
      setShowmenu(true)
    }
    if(isMobile){
      sliderRef.current.slickGoTo(3)
    }
  }
  const MobilehendleClip =(n)=>{
    setClipActive(n)
    if(n===3){
      vidRef3.current.play();
      vidRef4.current.pause();
      vidRef4.current.currentTime=0;
    }else{
      vidRef4.current.play();
      vidRef3.current.pause();
      vidRef3.current.currentTime=0;
    }
  }
  const hendleClip =(n)=>{
    setClipActive(n)
    if(n===1){
      vidRef1.current.play();
      vidRef2.current.pause();
      vidRef2.current.currentTime=0;
    }else{
      vidRef2.current.play();
      vidRef1.current.pause();
      vidRef1.current.currentTime=0;
    }
  }
  const toggleCarousel =()=>{
    if(clipActive===1){
      setClipActive(2)
      vidRef2.current.play();
      vidRef1.current.pause();
      vidRef1.current.currentTime=0;
    }else{
      setClipActive(1)
      vidRef1.current.play();
      vidRef2.current.pause();
      vidRef2.current.currentTime=0;
    }
  }
  const hendleChange=(e)=>{
    if(e.to===1){
      mainVdo.current.play();
    }else{
      mainVdo.current.pause();
      mainVdo.current.currentTime=0;
    }

    if(e.to===2){
      if(clipActive===1){
        vidRef1.current.play();
        vidRef2.current.pause();
        vidRef2.current.currentTime=0;
      }else{
        vidRef2.current.play();
        vidRef1.current.pause();
        vidRef1.current.currentTime=0;
      }
    }
    setActiveSlide(e.to)
  }
 
  const responseFacebook = (response) => {
    console.log(response);
    if (response.status === "unknown") {
      setLogin(false);
      return false;
    }
    setData(response);
    setPicture(response.picture.data.url);
    reactLocalStorage.set('popimg', response.picture.data.url)
    reactLocalStorage.setObject('profile',response)
    if (response.accessToken) {
      setLogin(true);
      let bodyFormData = new FormData();
      bodyFormData.append('fb_id', response.id);
      bodyFormData.append('fb_name', response.name);
      bodyFormData.append('fb_email', response.email);
      bodyFormData.append('score', 0);
      axios({
        method: "post",
        url: "https://www.goodyear.co.th/assurance-maxguard-suv/services/api/V1/join",
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(function (response) {
          window.location.href="/pumptire"
          console.log(response.data);
        })
        .catch(function (response) {
          //handle error
          console.log(response);
        });
     
    } else {
      setLogin(false);
    }
  }
  useEffect(() => {
    setY(window.scrollY);
  }, []);
  
  useEffect(() => {
    window.addEventListener("scroll", (e) => {
      let scrollH = document.body.scrollHeight * 0.75
      let secH = (scrollH/4) * 3
      let secVdo = (scrollH/4) * 2
      let mVdo = (scrollH/4) * 1
      if(document.documentElement.scrollTop > secH){
        setscrollDetect(true)
      }else{
        setscrollDetect(false)
      }
      if(!isMobile){
        if(document.documentElement.scrollTop > secVdo && document.documentElement.scrollTop < secH){
          if(clipActive===1){
            vidRef1.current.play()
            vidRef2.current.pause()
          }else{
            vidRef1.current.pause()
            vidRef2.current.play()
          }
        }

        if(document.documentElement.scrollTop > mVdo){
          mainVdo.current.play()
        }else{
          mainVdo.current.pause()
        }
      }
    });
    
    return () => { // return a cleanup function to unregister our function since its gonna run multiple times
      window.removeEventListener("scroll", (e) =>{
        let scrollH = document.body.scrollHeight * 0.75
        let secH = (scrollH/4) * 3
        let secVdo = (scrollH/4) * 2
        let mVdo = (scrollH/4) * 1
        if(document.documentElement.scrollTop > secH){
          setscrollDetect(true)
        }else{
          setscrollDetect(false)
        }
        if(!isMobile){
          if(document.documentElement.scrollTop > secVdo && document.documentElement.scrollTop < secH){
            if(clipActive===1){
              vidRef1.current.play()
              vidRef2.current.pause()
            }else{
              vidRef1.current.pause()
              vidRef2.current.play()
            }
          }

          if(document.documentElement.scrollTop > mVdo){
            mainVdo.current.play()
          }else{
            mainVdo.current.pause()
          }
        }
      });
    };
  }, [y]);
  return (
    <div className="App">
       <Helmet>
        <title>GOOD YEAR ASSURANCE MAXGUARD SUV</title>
        <meta name="ogtitle" property="og:title" content="GOOD YEAR ASSURANCE MAXGUARD SUV" />
        <meta property="og:type" ontent="website"/>
        <meta property="og:image" content="%PUBLIC_URL%/images/facebook-share.jpg"/>
        <meta property="og:description" content="ใหม่ GOOD YEAR ASSURANCE MAXGUARD SUV 2-IN-1 PROTECTION เบรกกระชับ รับแรงกระแทก" />
      </Helmet>
      <header className={`App-header ${(activeSlide===4)? "bg-transparent":""}`}>
        <div className="row">
          <div className={` menu ${(isMobile)? "col-3":"col-4"}` }>
            <a href="javascript:" onClick={togglemenu}><img src="../images/menu.png"/></a>
          </div>
          <div className={` ${(isMobile)? "col-6":"col-4"}` }>
            <img src="../goodyear-logo.png" className="logo"/>
          </div>
          <div className={`external ${(isMobile)? "col-3":"col-4 "}` }>
            {
            (!isMobile)?
            <>
            <a href="https://www.facebook.com/GoodyearThailand" target="_blank"><img src="../images/facebook-icon.png"/></a>
            <a href="https://www.goodyear.co.th/"  target="_blank"><img src="../images/web-icon.png"/></a>
            </>
            :
            <></>
            }
          </div>
        </div>
        <div className={`main-menu animate__animated ${(clickmenu)? "opt-1":"opt-0"} ${(showmenu)? "animate__slideInLeft":"animate__slideOutLeft"}` }>
          <ul>
            <li ><a href="#Vdo" onClick={togglemenu}>ไฮไลท์</a></li>
            <li><a href="#Information" onClick={togglemenu1}>ข้อมูลแสดงสมรรถนะของยาง</a></li>
            <li><a href="#Test" onClick={togglemenu2}>ผลการทดสอบสมรรถนะของยาง</a></li>
            <li><a href="#Size" onClick={togglemenu3}>ขนาดยาง</a></li>
            <li><a href="#pumptire" onClick={togglemenu}>กิจกรรม</a></li>
            <li><a href="https://www.goodyear.co.th/store" target="_blank" onClick={togglemenu}>ค้นหาตัวแทนจำหน่าย</a></li>
            <li><a href="#" onClick={()=>toggleContactModal()}>ติดต่อเรา</a></li> 
          </ul>
            {
            (isMobile)?
            <></>
            :
            <></>
            }
        </div>
      </header>
      <BrowserView>
      <FullPage  scrollMode="normal">
      <Slide className="section-1" id="Highlight">
        <Slider {...settings} className="banner-slider">
            <div>
              <img src="../bn-highlight.gif" width="100%"/>
            </div>
            {/* <div>
              <img src="../promotion_banner.jpg" width="100%"/>
            </div> */}
        </Slider>
      </Slide>
      <Slide className="section-5" id="pumptire">
        <div className="container h-100 p-relative">
          <div className="row view360 align-items-center h-100">
            <div className={"col-12"}>
              <img src="../images/poptire-logo.png" className={"poptire-img"}/>
              <div className="join_block">
              <FacebookLogin
                  appId="921615008736175"
                  autoLoad={false}
                  disableMobileRedirect={true}
                  fields="name,email,picture"
                  callback={responseFacebook}
                  cssClassNmaclassName="join_poptire"
                  version="2.3"
                  textButton="เข้าร่วมกิจกรรม"
                />
              </div>
            </div>
          </div>
        </div>
      </Slide>
      <Slide className="section-2" id="Vdo">
        <div className="container sec-vdo">
          <div className="row m-0">
            <div className="col-12 col-sm-12 col-md-9 main-vdo">
              {
                (oldCount !== VideoIndex)?
                  <video width="auto" height="100%" muted controls poster={videoLists[VideoIndex].poster} ref={mainVdo}>
                    <source src={videoLists[VideoIndex].url} type="video/mp4"/>
                  </video>
                  :
                  <video width="auto" height="100%" muted controls poster={videoLists[VideoIndex].poster} ref={mainVdo}>
                    <source src={videoLists[VideoIndex].url} type="video/mp4"/>
                  </video>
              }
            </div>
            <div className="col-12 col-sm-12 col-md-3 vdo-thumb">
                <div className="row">
                  {
                    videoLists.map((item,index) => (
                      (index !== VideoIndex)?
                      <div className="col-12 col-sm-12 col-md-12 vdo-item-col v-item" key={index}>
                        <img src={videoLists[index].poster} className="w-100 vdo_item" />
                        <div className="v-overlay" onClick={()=>clikVideo(index)}></div>
                      </div>
                      :
                      <></>
                    ))
                  }
                </div>
            </div>
          </div>
        </div>
      </Slide>
      <Slide className="section-3" id="Information">
        <div className="container h-100 p-relative">        
          <div className="row clip">
          <button className={"btn-control btn-prev"} onClick={()=>toggleCarousel()}/>
            <div className={`${(clipActive===1)? "col-7":"col-5"}`}>
              <div className={`c-item ${(clipActive===1)? "c-item-active":""}`} onClick={()=>hendleClip(1)}>
                <div className="image">
                  <video width="100%" height="auto" loop poster={"../clip1.jpg"} className="c-image" ref={vidRef1}>
                    <source src="../video/wet grip.mp4" type="video/mp4"/>
                  </video>
                  <img src="../c1.png" className="c-icon"/>
                </div>
                <div className="c-name">
                  <label>ยึดเกาะบนถนนเปียก</label>
                  <p className="text-center">
                    เนื้อยางซิลิกาคอมปาวด์สูตรพิเศษ เพิ่มประสิทธิภาพการเบรกและการยึดเกาะบนถนนเปียกที่ดีเยี่ยม
                  </p>
                </div>
              </div>
            </div>
            <div className={`${(clipActive===2)? "col-7":"col-5"}`}>
            <div className={`c-item ${(clipActive===2)? "c-item-active":""}`} onClick={()=>hendleClip(2)}>
                <div className="image">
                  <video width="100%" loop height="auto" poster={"../clip2.jpg"} className="c-image" ref={vidRef2}>
                    <source src="../video/duraguard.mp4" type="video/mp4"/>
                  </video>
                  <img src="../c2.png" className="c-icon"/>
                </div>
                <div className="c-name">
                  <label>แข็งแรง ทนทาน</label>
                  <p className="text-center">
                    โครงสร้าง 2 ชั้นผ้าใบ เพิ่มความแข็งแรงทนทานต่อการบาดและรับแรงกระแทกได้ดีขึ้น ทำให้คุณมั่นใจตลอดการเดินทาง
                  </p>
                </div>
              </div>
            </div>
            <button className={"btn-control btn-next"} onClick={()=>toggleCarousel()}/>
          </div>
        </div>
      </Slide>
      <Slide className="section-4">
        <div className="container h-100 p-relative" id="Test">
          <div className="row  align-items-center h-100"  id="Size">
            <div className={"col-7 view360"}>
              <img src="../images/wheel.png" className={"w-100 view-360"}/>
              <button className={"btn-360"} onClick={() => setModalShow(true)}/>
            </div>
            <div className={"col-5 position-relative"}>
              <button className="btn-tab-control btn-tab-control-prev" onClick={() => toggleTab(tabIndex)}><img src="../images/p.png"/></button>
              <Tabs selectedIndex={tabIndex} onSelect={index=>setTabIndex(index)}>
                <TabList>
                  <Tab>ผลการทดสอบสมรรถนะ</Tab>
                  <Tab>ขนาดยาง</Tab>
                </TabList>
                <TabPanel>
                  <img src="../images/spider-chart.png" className={`w-100 animate__animated ${(scrollDetect)? "animate__zoomIn animate__delay-1s	1s ":""}`} />
                </TabPanel>
                <TabPanel>
                  <img src="../images/size.png" className={`w-100 animate__animated ${(tabIndex===1)? "animate__zoomIn animate__delay-1s	1s ":""}`}/>
                </TabPanel>
              </Tabs>
              <button className="btn-tab-control btn-tab-control-next" onClick={() => toggleTab(tabIndex)}><img src="../images/n.png"/></button>
            </div>
          </div>
        </div>
      </Slide>
      
    </FullPage>    
    </BrowserView>
    <MobileView>
      <div className="section-1" id="Highlight">
        <Slider {...settings}>
            <div>
              <img src="../bn-highlight.gif" width="100%"/>
            </div>
            <div>
              <img src="../promotion_banner.jpg" width="100%"/>
            </div>
        </Slider>
        <div className="clearboth"></div>
      </div>
      <div className="section-5" id="pumptire">
        <div className="container h-100 p-relative">
          <div className="row  align-items-center h-100">
            <div className={"col-12"}>
              <img src="../images/poptire-logo.png" className={"poptire-img m-poptire-img"}/>
              <div className="join_block">
              <FacebookLogin
                  appId="921615008736175"
                  autoLoad={false}
                  disableMobileRedirect={true}
                  fields="name,email,picture"
                  callback={responseFacebook}
                  cssClassNmaclassName="join_poptire"
                  version="2.3"
                  textButton="เข้าร่วมกิจกรรม"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section-2" id="Vdo">
        <div className="container p-0 sec-vdo">
          {
            (oldCount !== VideoIndex)?
              <video width="100%" height="auto" controls muted autoPlay poster={videoLists[VideoIndex].poster} ref={mainVdo}>
                <source src={videoLists[VideoIndex].url} type="video/mp4"/>
              </video>
              :
              <video width="100%" height="auto" controls muted autoPlay poster={videoLists[VideoIndex].poster} ref={mainVdo}>
                <source src={videoLists[VideoIndex].url} type="video/mp4"/>
              </video>
          }
        </div>
        <div className="container p-0">
        <div className="row m-0 m-thum-vdo">
                  {
                    videoLists.map((item,index) => (
                      (index !== VideoIndex)?
                      <div className="col-4 col-sm-4 col-md-4 p-2 v-item" key={index}>
                          <div className="p-relative">
                            <img src={videoLists[index].poster} className="w-100"/>
                            <div className="v-overlay"  onClick={()=>clikVideo(index)}></div>
                          </div>
                      </div>
                      :
                      <></>
                    ))
                  }
                </div>
        </div>
      </div>
      <div className="section-3 mobile" id="Information">
        <div className="container h-100 p-relative">  
            <Slider  ref={sliderRef} {...settings2} className="tab-slide">      
            <div className="row bg-overlay">
              <div className={`col-12 p-0`}>
                  <div className={`c-item c-item-active `}>
                    <div className="image">
                      <video width="100%" height="auto" poster={"../clip1.jpg"} autoPlay muted loop className="c-image" ref={vidRef3} onClick={()=>MobilehendleClip(3)}>
                        <source src="../video/wet grip.mp4" type="video/mp4"/>
                      </video>
                    </div>
                  </div>
              </div>
              <div className={`col-12 p-0 `}>
                  <div className="c-name">
                  <img src="../c1.png" className="c-icon"/>
                    <label>ยึดเกาะบนถนนเปียก</label>
                    <p>
                    เนื้อยางซิลิกาคอมปาวด์สูตรพิเศษ เพิ่มประสิทธิภาพการเบรกและการยึดเกาะบนถนนเปียกที่ดีเยี่ยม
                    </p>
                  </div>
              </div>
            </div>
            <div className="row bg-overlay">
              <div className={`col-12 p-0`}>
                  <div className={`c-item  c-item-active `}>
                    <div className="image">
                      <video width="100%" height="auto" poster={"../clip2.jpg"} loop muted autoPlay className="c-image" ref={vidRef4} onClick={()=>MobilehendleClip(4)}>
                          <source src="../video/duraguard.mp4" type="video/mp4"/>
                      </video>
                    </div>
                  </div>
              </div>
              <div className={`col-12 p-0`}>
                <div className="c-name">
                    <img src="../c2.png" className="c-icon"/>
                      <label>แข็งแรง ทนทาน</label>
                      <p>
                      โครงสร้าง 2 ชั้นผ้าใบ เพิ่มความแข็งแรงทนทานต่อการบาดและรับแรงกระแทกได้ดีขึ้น ทำให้คุณมั่นใจตลอดการเดินทาง
                      </p>
                </div>
              </div>
           </div>
           <div className="row bg-overlay" id="Test">
            <div className={"col-12 p-0"}>
                <Tabs className="tab-cm">
                  <TabList>
                    <Tab>ผลการทดสอบสมรรถนะ</Tab>
                  </TabList>
                  <TabPanel>
                    <img src="../images/spider-chart.png" className={`w-100 animate__animated ${(sliderIndex===2)? "animate__zoomIn animate__delay-1s	1s ":""}`} />
                  </TabPanel>
                </Tabs>
              </div>
            </div>
            <div className="row bg-overlay" id="Size">
            <div className={"col-12 p-0"}>
                <Tabs className="tab-cm">
                  <TabList>
                    <Tab>ขนาดยาง</Tab>
                  </TabList>
                  <TabPanel>
                    <img src="../images/size.png" className={`w-100 animate__animated ${(sliderIndex===3)? "animate__zoomIn animate__delay-1s	1s ":""}`} />
                  </TabPanel>
                </Tabs>
              </div>
            </div>
           </Slider>
        </div>
      </div>
      <div className="section-4" id="lab">
        <div className="container h-100 p-relative p-0">
          <div className="row  align-items-center h-100">
            <div className={"col-12 view360"}>
              <img src="../images/wheel.png" className={"w-100 view-360"}/>
              <button className={"btn-360"} onClick={() => setModalShow(true)}/>
            </div>
          </div>
        </div>
      </div>
      
     
      <div className="footer-tab">
        <div className="row m-0 align-items-center">
          <div className="col-6">
            <a href="https://www.facebook.com/GoodyearThailand"  target="_blank"><img src="../images/facebook-icon2.png"/> Goodyear Thailand</a>
          </div>
          <div className="col-6">
            <a href="https://www.goodyear.co.th/"  target="_blank"><img src="../images/web-icon2.png"/> Goodyear Website </a>
          </div>
        </div>
      </div>
    </MobileView>
      <Fbxmodal show={modalShow} onHide={() => setModalShow(false)}/>
      <Contactmodal show={ContactModalShow} onHide={()=>setContactModalShow(false)} />
    </div>
  );
}
export default class Home extends React.Component{
  render(){
    return(
      <Mainpage/>
    )
  }
}
